import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SOURCE_URL } from "../../../config";
import Swiper from 'swiper';
import 'swiper/css/bundle';
import { swiperConfigs } from './BlogSwiperConfigs';

const BlogBannerArticles: React.FC<{ bannerArticles: any[] }> = ({ bannerArticles }) => {
  const initializeSwiper = () => {
    document.querySelectorAll<HTMLElement>(".home-swiper").forEach((container) => {
      new Swiper(container as HTMLElement, swiperConfigs.homeBannerConfig);
    });
  };

  useEffect(() => {
    if (bannerArticles) {
      initializeSwiper();
    }
  }, [bannerArticles]);

  return (
    bannerArticles && bannerArticles.length > 0 && (
      <div className="home-swiper">
        <div className="swiper-wrapper">
          {bannerArticles.slice(0, 10).map((article) => (
            <div key={article.id} className="swiper-slide">
              <Link to={`${article.attributes.slug}`}>
                <img src={article?.attributes?.FeaturedImage?.data?.attributes?.url ? SOURCE_URL + article?.attributes?.FeaturedImage?.data?.attributes?.url : ''} alt="banner" />
              </Link>
            </div>
          ))}
        </div>

        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
        <div className="swiper-pagination"></div>
      </div>
    )
  );
};

export default BlogBannerArticles;